import { render } from "./TpIcon.vue?vue&type=template&id=6c40a9ac"
import script from "./TpIcon.vue?vue&type=script&lang=js"
export * from "./TpIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__